export const status = {
  AGUARDANDO_HOMOLOGACAO: 0,
  HOMOLOGADO: 1,
  CANCELADO: 2,
};
export const labelStatusVinculo = [
  "Aguardando homologação",
  "Homologado",
  "Cancelado",
];

export const opcoesListaPacientes = {
  EM_ATRASO: 0,
  EM_TRATAMENTO: 1,
  CONSULTAS_DO_DIA: 2,
};
